module.exports = __webpack_public_path__ + "img/import.965aba34.png";